<template>
    <div class="nodata" :class="{mini:mini}" v-show="isShow">
        <div class="nodata-in">
            <img class="nodata_img" :src="require('./img/'+ category +'.gif')" alt="">
            <div class="nodata_word">{{tipword}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NoData',
        props: {
            category: {
                type: String,
                default: 'content', //  暂无内容 content， 暂无优惠券 coupon, 暂无课程 lesson, 断网 network, 定位为空 position
            },
            tipword: {
                type: String,
                default: '暂无内容'
            },
            mini:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
               timer: null,
                isShow: false,
            }
        },
        created() {
            this.timer = setInterval(() => {
                this.isShow = true;
            }, 500);
        },
        beforeDestroy() {
            window.clearTimeout(this.timer)
        }
    }
</script>
<style lang="scss" scoped>
    .nodata {
        background: #ffffff;
        padding-top: 150px;
        &-in {
            text-align: center;
        }
        &_img {
            display: inline-block;
            width: 187px;
        }
        &_word {
            font-size:17px;
            font-weight:400;
            color:rgba(34,34,34,1);
        }

    }
    .mini{
        padding-top: 20px;
    }
</style>
